"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutePlanTemplateStopUpdate = exports.RoutePlanTemplateStopCreate = exports.RoutePlanTemplateStopQuery = exports.RoutePlanTemplateStopTransport = exports.RoutePlanTemplateStop = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const AbstractRouteStop_1 = require("../common/AbstractRouteStop");
const ServicePeriod_1 = require("../subscriptions-and-billing/ServicePeriod");
const OneOffPickupRequest_1 = require("./OneOffPickupRequest");
exports.RoutePlanTemplateStop = typebox_1.Type.Composite([
    AbstractRouteStop_1.AbstractRouteStop,
    typebox_1.Type.Object({
        routePlanTemplateID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        oneOffPickupRequest: typebox_1.Type.Optional(OneOffPickupRequest_1.OneOffPickupRequest),
        active: typebox_1.Type.Boolean({
            description: 'If false, then automatic scheduling will no longer add this stop to route plans. Defaults to true.',
        }),
        currentServicePeriod: typebox_1.Type.Optional(ServicePeriod_1.ServicePeriod),
    }),
]);
exports.RoutePlanTemplateStopTransport = exports.RoutePlanTemplateStop;
exports.RoutePlanTemplateStopQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    AbstractRouteStop_1.AbstractRouteStopQuery,
    typebox_1.Type.Object({
        routePlanTemplateID: typebox_1.Type.String({ format: 'uuid' }),
        active: typebox_1.Type.Boolean(),
        isOrphaned: typebox_1.Type.Boolean(),
    }),
]));
exports.RoutePlanTemplateStopCreate = typebox_1.Type.Omit(exports.RoutePlanTemplateStop, [
    'id',
    'haulerID',
    'oneOffPickupRequest',
    'subscriptionEquipment',
    'metadata',
]);
exports.RoutePlanTemplateStopUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanTemplateStop, [
        'id',
        'haulerID',
        'oneOffPickupRequest',
        'subscriptionEquipment',
        'routePlanTemplateID',
        'metadata',
    ]),
    typebox_1.Type.Object({
        routePlanTemplateID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    }),
]));
//# sourceMappingURL=RoutePlanTemplateStop.js.map